import React from 'react';
import Colors from '../helpers/Colors';
import Config from '../../assets/config.json';
import Locale from '../../assets/languages';

class Map extends React.Component {
	constructor(props) {
		super(props);

		this.map = false;
		this.dataLayer = [];
		this.infoWindow = false;
		this.municipalities = [];
		this.colors = [];

		this.Init = this.Init.bind(this);
		this.GeoJSON = this.GeoJSON.bind(this);
		this.SetStyles = this.SetStyles.bind(this);
		this.Colors = new Colors();
	}

	componentDidMount() {
		const colors1 = this.Colors.Gradient(Config.COLORS.LIGHT, Config.COLORS.MEDIUM, 51);
		const colors2 = this.Colors.Gradient(Config.COLORS.MEDIUM, Config.COLORS.DARK, 51);

		colors1.pop();
		this.colors = colors1.concat(colors2);

		//

		if (!window.google) {
			let script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.google.com/maps/api/js?key=' + Config.GMAP.API;

			let body = document.querySelector('body');
			body.append(script);

			//

			script.addEventListener('load', () => {
				this.Init();
			});
		} else
			this.Init();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.LoaderToggle
			&& typeof (this.props.LoaderToggle) === 'function')
			this.Init();
	}

	Init() {
		if (window.google) {
			this.map = new window.google.maps.Map(
				document.getElementById('Map'),
				{
					mapId: Config.GMAP.ID,
					center: { lat: 56.212859, lng: 9.3004531 },
					zoom: 7,
					zoomControl: true,
					zoomControlOptions: {
						style: window.google.maps.ZoomControlStyle.SMALL,
						position: window.google.maps.ControlPosition.LEFT_TOP
					},
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false
				});

			//

			this.GeoJSON(Config.API.ENDPOINT + '/municipalities.geojson');
		}
	}

	GeoJSON(json) {
		if (window.google) {
			this.props.LoaderToggle(true, 'map');

			for (var i = 0; i < this.dataLayer.length; i++)
				this.map.data.remove(this.dataLayer[i]);

			//

			fetch(Config.API.ENDPOINT,
				{
					method: 'POST',
					mode: 'cors',
					body: JSON.stringify({
						action: 'GetMunicipalities',
						token: Config.API.TOKEN
					})
				})
				.then(response => response.json())
				.then(
					(result) => {
						if (result.status) {
							this.municipalities = result.results;

							//

							fetch(json)
								.then(response => response.json())
								.then(
									(result) => {
										this.infoWindow = new window.google.maps.InfoWindow();
										this.dataLayer = this.map.data.addGeoJson(result);
										this.SetStyles();

										//

										let bounds = new window.google.maps.LatLngBounds();

										this.map.data.forEach(feature => {
											let municipality = this.municipalities.filter(function (m) {
												return m.code === feature.getProperty('code');
											});
											if (municipality.length === 0)
												console.warn(feature.getProperty('code'), feature.getProperty('name'));

											if (municipality.length > 0)
												feature.setProperty('name', municipality[0].name);

											feature.setProperty('ranking', municipality.length > 0 ? municipality[0].ranking : 0);
											feature.setProperty('avgPercentage', municipality.length > 0 ? municipality[0].avgPercentage : 0);
											feature.setProperty('avgScore', municipality.length > 0 ? municipality[0].avgScore : 0);
											feature.setProperty('relArea', municipality.length > 0 ? municipality[0].relArea : 0);
											feature.setProperty('totArea', municipality.length > 0 ? municipality[0].totArea : 0);
											feature.setProperty('totUsers', municipality.length > 0 ? municipality[0].totUsers : 0);

											//

											let subBounds = new window.google.maps.LatLngBounds();

											feature.getGeometry().getArray().forEach(path => {
												path.getArray().forEach(latLng => {
													bounds.extend(latLng);
													subBounds.extend(latLng);
												});
											});
											feature.setProperty('bounds', subBounds);
										});

										//

										const padding = 1.5;
										const restrictionBounds = new window.google.maps.LatLngBounds(
											new window.google.maps.LatLng(bounds.getSouthWest().lat() - padding, bounds.getSouthWest().lng() - padding),
											new window.google.maps.LatLng(bounds.getNorthEast().lat() + padding, bounds.getNorthEast().lng() + padding)
										)
										this.map.set('restriction', {
											latLngBounds: restrictionBounds,
											strictBounds: false
										});
										this.map.fitBounds(bounds);
										this.map.setZoom(7);

										//

										this.map.data.addListener('mouseover', (e) => {
											this.map.data.revertStyle();
											this.map.data.overrideStyle(e.feature, {
												strokeWeight: 1,
												fillColor: '#eae835',
												fillOpacity: 1,
												zIndex: 99999
											});
										});
										this.map.data.addListener('mouseout', (e) => {
											this.map.data.revertStyle();
										});
										this.map.data.addListener('click', (e) => {
											let content = '<h6 class="mt-0 mb-2">' + e.feature.getProperty('name') + ' ' + Locale.MAP.MUNICIPALITY + '</h6>';
											content += '<ul class="list-unstyled mb-0">';
											content += '<li class="mt-1"><strong>' + Intl.NumberFormat(Config.LOCALE).format(e.feature.getProperty('totUsers')) + '</strong> ' + Locale.MAP.TOT_USERS + '</li>';
											content += '<li class="mt-1"><strong>' + Intl.NumberFormat(Config.LOCALE).format(e.feature.getProperty('relArea')) + '</strong> ' + Locale.MAP.REL_AREA + '</li>';
											content += '</ul>';

											this.infoWindow.setContent(content);
											this.infoWindow.setPosition(e.feature.getProperty('bounds').getCenter());
											this.infoWindow.open(this.map);
										});
										window.google.maps.event.addListener(this.map, 'click', (e) => {
											this.infoWindow.close();
										});
										this.props.LoaderToggle(false, 'map');
									},
									(error) => {
										console.error(error);
									});
						}
					},
					(error) => {
						console.error(error);
					});
		}
	}

	SetStyles(scorePerc) {
		scorePerc = scorePerc ? scorePerc : 'percRelUsers';

		if (this.map.data) {
			this.map.data.setStyle(feature => {
				const municipality = this.municipalities.filter(function (m) {
					return m.code === feature.getProperty('code');
				});
				const color = municipality.length > 0 ? this.colors[Math.round(municipality[0][scorePerc])] : this.colors[0];
				const opacity = 1;

				return {
					strokeWeight: 0.5,
					strokeColor: '#fff',
					fillColor: 'rgb(' + color.join(', ') + ')',
					fillOpacity: opacity
				};
			});
		}
	}

	render() {
		return <article className={this.props.className}>
			<div id="Map" style={{ width: '100%', height: '100%' }} />
			{this.props.children}
		</article>
	}
}

export default Map;